import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
/* eslint-disable eqeqeq */
/* eslint-disable semi */
/* eslint-disable no-console */

/**
 * 图片处理模块
 * @module image
 */

import { $isServer } from "./env";

/**
 * 检查图片是否有被压扁，如果有，返回比率
 * ref to http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 * @ignore
 */
function detectVerticalSquash(img) {
  // 拍照在IOS7或以下的机型会出现照片被压扁的bug
  var data;
  var ih = img.naturalHeight;
  var canvas = document.createElement('canvas');
  canvas.width = 1;
  canvas.height = ih;
  var ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  try {
    // eslint-disable-next-line prefer-destructuring
    data = ctx.getImageData(0, 0, 1, ih).data;
  } catch (err) {
    console.error('Cannot check verticalSquash: CORS?');
    return 1;
  }
  var sy = 0;
  var ey = ih;
  var py = ih;
  while (py > sy) {
    var alpha = data[(py - 1) * 4 + 3];
    if (alpha === 0) {
      ey = py;
    } else {
      sy = py;
    }
    py = ey + sy >> 1; // py = parseInt((ey + sy) / 2)
  }
  var ratio = py / ih;
  return ratio === 0 ? 1 : ratio;
}

/**
 * dataURI to blob, ref to https://gist.github.com/fupslot/5015897
 * @param dataURI
 * @ignore
 */
export function dataURItoBuffer(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var buffer = new ArrayBuffer(byteString.length);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < byteString.length; i++) {
    view[i] = byteString.charCodeAt(i);
  }
  return buffer;
}

/**
 * dataURI to blob, ref to https://gist.github.com/fupslot/5015897
 * @param dataURI
 * @ignore
 */
export function dataURItoBlob(dataURI) {
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  var buffer = dataURItoBuffer(dataURI);
  return new Blob([buffer], {
    type: mimeString
  });
}

/**
 * 获取图片的orientation
 * ref to http://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
 * @ignore
 */
function getOrientation(buffer) {
  var view = new DataView(buffer);
  if (view.getUint16(0, false) != 0xffd8) return -2;
  var length = view.byteLength;
  var offset = 2;
  while (offset < length) {
    var marker = view.getUint16(offset, false);
    offset += 2;
    // eslint-disable-next-line eqeqeq
    if (marker == 0xffe1) {
      // eslint-disable-next-line no-cond-assign
      if (view.getUint32(offset += 2, false) !== 0x45786966) return -1;
      // eslint-disable-next-line eqeqeq
      var little = view.getUint16(offset += 6, false) == 0x4949;
      offset += view.getUint32(offset + 4, little);
      var tags = view.getUint16(offset, little);
      offset += 2;
      for (var i = 0; i < tags; i++) {
        // eslint-disable-next-line eqeqeq
        if (view.getUint16(offset + i * 12, little) == 0x0112) {
          return view.getUint16(offset + i * 12 + 8, little);
        }
      }
      // eslint-disable-next-line eqeqeq
    } else if ((marker & 0xff00) != 0xff00) break;else offset += view.getUint16(offset, false);
  }
  return -1;
}

/**
 * 修正拍照时图片的方向
 * ref to http://stackoverflow.com/questions/19463126/how-to-draw-photo-with-correct-orientation-in-canvas-after-capture-photo-by-usin
 * @ignore
 */
function orientationHelper(canvas, ctx, orientation) {
  var w = canvas.width;
  var h = canvas.height;
  if (orientation > 4) {
    canvas.width = h;
    canvas.height = w;
  }
  switch (orientation) {
    case 2:
      ctx.translate(w, 0);
      ctx.scale(-1, 1);
      break;
    case 3:
      ctx.translate(w, h);
      ctx.rotate(Math.PI);
      break;
    case 4:
      ctx.translate(0, h);
      ctx.scale(1, -1);
      break;
    case 5:
      ctx.rotate(0.5 * Math.PI);
      ctx.scale(1, -1);
      break;
    case 6:
      ctx.rotate(0.5 * Math.PI);
      ctx.translate(0, -h);
      break;
    case 7:
      ctx.rotate(0.5 * Math.PI);
      ctx.translate(w, -h);
      ctx.scale(-1, 1);
      break;
    case 8:
      ctx.rotate(-0.5 * Math.PI);
      ctx.translate(-w, 0);
      break;
  }
}

/**
 * 压缩图片，同时修正拍摄的图片方向和图片被压扁的问题
 * @method compress
 * @param {File} file 上传的图片文件
 * @param {Object} options 配置参数
 * @param {enum} [options.type=base64] 上传配置，可设置为'file'上传源文件
 * @param {Object|Boolean} options.compress 压缩配置
 * @param {Number} options.compress.width 压缩后的宽度
 * @param {Number} options.compress.height 压缩后的高度
 * @param {Number} options.compress.quality 压缩质量，0-1
 * @param {Function} options.compress.onError(file,error) 压缩失败回调
 * @param {Function} callback(file) 压缩完成回调
 */
export function compress(file, options, callback) {
  if ($isServer) return;
  var reader = new FileReader();
  reader.onload = function (evt) {
    if (options.compress === false) {
      // 不启用压缩 & base64上传 的分支，不做任何处理，直接返回文件的base64编码
      file.base64 = evt.target.result;
      callback(file);
      return;
    }

    // 启用压缩的分支
    var img = new Image();
    img.onload = function () {
      var ratio = detectVerticalSquash(img);
      var orientation = getOrientation(dataURItoBuffer(img.src));
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var maxW = options.compress.width;
      var maxH = options.compress.height;
      var w = img.width;
      var h = img.height;
      var dataURL;
      if (w < h && h > maxH) {
        // eslint-disable-next-line radix
        w = parseInt(maxH * img.width / img.height);
        h = maxH;
      } else if (w >= h && w > maxW) {
        // eslint-disable-next-line radix
        h = parseInt(maxW * img.height / img.width);
        w = maxW;
      }
      canvas.width = w;
      canvas.height = h;
      if (orientation > 0) {
        orientationHelper(canvas, ctx, orientation);
      }
      ctx.drawImage(img, 0, 0, w, h / ratio);
      if (/image\/jpeg/.test(file.type) || /image\/jpg/.test(file.type)) {
        dataURL = canvas.toDataURL('image/jpeg', options.compress.quality);
      } else {
        dataURL = canvas.toDataURL(file.type);
      }
      if (options.type == 'file') {
        if (/;base64,null/.test(dataURL) || /;base64,$/.test(dataURL)) {
          // 压缩出错，以文件方式上传的，采用原文件上传
          console.warn('Compress fail, dataURL is ' + dataURL + '. Next will use origin file to upload.');
          callback(file);
        } else {
          var blob = dataURItoBlob(dataURL);
          blob.id = file.id;
          blob.name = file.name;
          blob.lastModified = file.lastModified;
          blob.lastModifiedDate = file.lastModifiedDate;
          callback(blob);
        }
      } else if (/;base64,null/.test(dataURL) || /;base64,$/.test(dataURL)) {
        // 压缩失败，以base64上传的，直接报错不上传
        options.onError(file, new Error('Compress fail, dataURL is ' + dataURL + '.'));
        callback(file);
      } else {
        file.base64 = dataURL;
        callback(file);
      }
    };
    img.src = evt.target.result;
  };
  reader.readAsDataURL(file);
}

/**
 * TODO: 生成截图
 * @method getScreenShot
 * @return {String}
 * @ignore
 */
export function getScreenShot() {}
export default {
  compress: compress,
  getScreenShot: getScreenShot
};